import React, { Component } from "react";
import { vendasestado, runVerificaAutenticacao } from "../../../services/api";
import GridTable from "../../../lib/GridTable";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Header from "../../../components/Header";
import {
  TablesGridContainer,
  TablesGridContainerContent,
  TablesGridContainerText,
  TablesGridCoontentFilter,
  TablesGridCoontentFilterSelector,
  TablesGridCoontentFilterSelectorButton,
} from "./styles";

class VendasEstado extends Component {
  constructor(props) {
    super(props);
    this.state = { dataStart: "", dataEnd: "", dados: [] };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(event) {
    event.preventDefault();

    const { dataStart, dataEnd } = this.state;
    this.getLessons(dataStart, dataEnd);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  componentDidMount() {
    runVerificaAutenticacao();
  }

  getLessons = async (dateStart, endDate) => {
    const startDate = dateStart;
    const dataFinal = endDate;

    try {
      const response = await vendasestado.get(startDate + "/" + dataFinal);

      this.setState({ dados: response.data });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  render() {
    const { dados, dateStart, endDate } = this.state;

    function priceFormatter(value) {
      var atual = value
        ? parseFloat(value).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        : "";
      return atual;
    }

    function integerFormatter(value) {
      var atual = value
        ? parseFloat(value).toLocaleString("pt-BR", {
            minimumIntegerDigits: 2,
            minimumFractionDigits: 0,
          })
        : "";
      return atual;
    }

    const columns = [
      {
        dataField: "uf",
        text: "Estado",
      },
      {
        dataField: "quantidade_propostas",
        text: "Propostas",
        formatter: integerFormatter,
        sort: true,
      },
      {
        dataField: "quantidade_pedidos",
        text: "Pedidos",
        formatter: integerFormatter,
        sort: true,
      },
      {
        dataField: "valor_total_pedidos",
        text: "Valor",
        formatter: priceFormatter,
        sort: true,
      },
      {
        dataField: "percentual_total_vendas",
        text: "Porcentual de venda",
        sort: true,
      },
      {
        dataField: "valor_medio_pedido",
        text: "Ticket Médio",
        formatter: priceFormatter,
        sort: true,
      },
    ];

    return (
      <>
        <TablesGridContainer>
          <form onSubmit={this.handleSubmit}>
            <TablesGridContainerContent>
              <TablesGridContainerText>
                <h1>
                  VENDAS <strong>ESTADO</strong>
                </h1>
              </TablesGridContainerText>
              <TablesGridCoontentFilter>
                <TablesGridCoontentFilterSelector>
                  <label
                    htmlFor=""
                  >
                    Data Início:{" "}
                  </label>
                  <input
                    name="dataStart"
                    type="date"
                    value={this.state.dataStart}
                    onChange={this.handleChange}
                  />
                </TablesGridCoontentFilterSelector>

                <TablesGridCoontentFilterSelector>
                  <label
                    htmlFor=""
                  >
                    Data Final:{" "}
                  </label>
                  <input
                    name="dataEnd"
                    type="date"
                    value={this.state.dataEnd}
                    onChange={this.handleChange}
                  />
                </TablesGridCoontentFilterSelector>

                <TablesGridCoontentFilterSelectorButton>
                  Aplicar
                </TablesGridCoontentFilterSelectorButton>
              </TablesGridCoontentFilter>

              {dados.length > 0 ? (
                <GridTable dados={dados} columns={columns} />
              ) : (
                <></>
              )}
            </TablesGridContainerContent>
          </form>
        </TablesGridContainer>
      </>
    );
  }
}

export default VendasEstado;
